import Vue from 'vue'

export default {
    list(params) {
        return Vue.axios.get(`/cutlery-items`, {params})
    },
    get(id) {
        return Vue.axios.get(`/cutlery-items/${id}`)
    },
    create(params) {
        return Vue.axios.post(`/cutlery-items`, params)
    },
    update(id, params) {
        return Vue.axios.post(`/cutlery-items/${id}`, {...params, ...{'_method': 'patch'}})
    },
    remove(id){
        return Vue.axios.post(`/cutlery-items/${id}`, {'_method': 'delete'})
    },
}
